export const fetchCMSContent = async (collectionName) => {
  try {
    const response = await fetch(`https://api.dev.auxo.dk/public/content/${collectionName}`);
    if (!response.ok) throw new Error('Failed to fetch CMS content');
    return await response.json();
  } catch (error) {
    console.error(`Error fetching ${collectionName}:`, error);
    return [];
  }
};
